

























































import {
  computed, ref, reactive,
  defineComponent, toRefs,
} from 'vue-demi';
import clonedeep from 'lodash.clonedeep';
import { ANIMATION_TYPES } from '@/utils/constant.ts';
import { AnimationType } from '@/utils/types.ts';
import SvgIcon from './SvgIcon.vue';
import Prop from './Prop.vue';

export default defineComponent({
  components: {
    SvgIcon,
    Prop,
  },
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    time: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
    id: {
    },
  },
  setup(props, { emit }) {
    const { option, id } = toRefs(props);
    const animationTypes = reactive(clonedeep(ANIMATION_TYPES));
    const isShowAnimations = ref(false);
    const name = computed(() => option.value.name);
    const visible = computed(() => option.value.visible);
    const isExpanded = computed(() => option.value.isExpanded);
    const isLocked = computed(() => option.value.isLocked);
    const animations = computed(() => option.value.animations);

    const isActive = (prop: string) => animations.value.find((animation: AnimationType) => animation.prop === prop);

    const handleUpdate = () => {
      emit('update', { transition: option.value, key: id?.value });
    };

    const handleTimeUpdate = (t: number) => {
      emit('timeUpdate', t);
    };

    const handleShowAnimations = () => {
      isShowAnimations.value = !isShowAnimations.value;
    };

    const handleSelectAnimation = (animationType: AnimationType) => {
      option.value.isExpanded = true;
      const target = animations.value.find(
        (animation: AnimationType) => animation.prop === animationType.prop,
      );
      if (!target) {
        const propList = ['width', 'height', 'top', 'left'];
        if (propList.includes(animationType.prop)) {
          Object.assign(animationType, { value: option.value[animationType.prop] });
        }
        const { anchors, prop } = animationType;
        animations.value.push(reactive({ anchors, prop }));
      } else {
        const index = animations.value.findIndex(
          (animation: AnimationType) => animation.prop === target.prop,
        );
        animations.value.splice(index, 1);
      }
      handleUpdate();
    };

    const handleVisible = () => {
      option.value.visible = !option.value.visible;
      emit('update', { transition: option.value, key: id?.value });
    };

    const handleLocked = () => {
      option.value.isLocked = !option.value.isLocked;
      handleUpdate();
    };

    const handleExpanded = () => {
      option.value.isExpanded = !option.value.isExpanded;
      handleUpdate();
    };

    const handleRemove = ({ prop }: AnimationType) => {
      const index = animations.value.findIndex((animation: AnimationType) => animation.prop === prop);
      const defaultAnimationType = ANIMATION_TYPES.find((animationType) => animationType.prop === animations.value[index].type);
      Object.assign(animations.value[index], defaultAnimationType);
      animations.value.splice(index, 1);
      handleUpdate();
    };

    return {
      name,
      visible,
      isExpanded,
      isLocked,
      isShowAnimations,
      animations,
      animationTypes,
      isActive,
      handleVisible,
      handleLocked,
      handleExpanded,
      handleShowAnimations,
      handleSelectAnimation,
      handleRemove,
      handleUpdate,
      handleTimeUpdate,
    };
  },
});
